export default "__VITE_ASSET__COBygjGn__"